<template>
    <div id="laborCostList">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title">Labor Cost List</div>
                    <router-link v-if="canAddLaborCost" class="btn btn-primary pull-right" v-bind:to="{name: 'LaborCostCreate'}" > <i class="fp-add"> </i> Add</router-link>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content term-list">
                        <data-table-filter-config :moduleName="'laborCostList'" ref="filterLaborCostList" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'laborCostList'" :position="'top'">
                                </custom-pagination>

                                <vue-good-table
                                    ref="listLaborCostTable"
                                    mode="remote"
                                    title="Labor Cost"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                    enabled: labor_cost_value,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'">
                                                <template v-if="canUpdateLaborCost">
                                                    <router-link title="Edit Labor Cost" class="fp-edit" v-bind:to="{name: 'LaborCostEdit',params:{id:props.row.id}}"></router-link>
                                                    <router-link title="View Labor Cost" class="ml-3 fp-view" v-bind:to="{name: 'LaborCostView',params:{id:props.row.id}}"></router-link>
                                                </template>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>

                                    <div slot="selected-row-actions">
                                        <button v-if="labor_cost_value" id="deleteLaborCostBtn" v-on:click.prevent="laborCostDelete" class="btn btn-danger">Delete</button>
                                    </div>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";


import EventBus from "./event-bus";


import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

export default {
    name: "LaborCostList",
    metaInfo() {
        return {title: "Labor Cost List | " +process.env.COPYRIGHT_NAME}
    },
    mixins:[commonMixins,dataTableMixins],
    data: () => ({
        firstLoad: 0,
        permissions: [],
        cantAccessPage: "",
        userColumns:[],
        columns: [
            {
                label: 'Actions',
                field: 'action',
                sortable: false,
                hidden:false,
            },
            {
                label: 'Type',
                field:'type',
                filterable: true,
                fpFieldType:"option",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Type", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Cost Code',
                field: 'cost_code',
                filterable: true,
                hidden:false,
                fpFieldType:"option",
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Cost Code", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Effective Date',
                field: 'effective_date',
                filterable: true,
                hidden:false,
                fpFieldType:"date",
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Effective Date", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Hourly Rate',
                field: 'hourly_rate',
                fpFieldType:"integer",
                type: 'number',
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Hourly Rate", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            // {
            //     label: 'Customer',
            //     field: 'customer',
            //     filterable: true,
            //     fpFieldType:"text",
            //     hidden:false,
            //     filterOptions: {
            //         enabled: false, // enable filter for this column
            //         placeholder: "Customer", // placeholder for filter input
            //         filterValue: '', // initial populated value for this filter
            //         trigger: "enter" //only trigger on enter not on keyup
            //     }
            // },
            // {
            //     label: 'Customer Class',
            //     field: 'customer_class',
            //     filterable: true,
            //     fpFieldType:"option",
            //     hidden:false,
            //     filterOptions: {
            //         enabled: false, // enable filter for this column
            //         placeholder: "Customer Class", // placeholder for filter input
            //         filterValue: '', // initial populated value for this filter
            //         trigger: "enter" //only trigger on enter not on keyup
            //     }
            // },
            // {
            //     label: 'Contract Type',
            //     field: 'fp_contract_type',
            //     filterable: true,
            //     fpFieldType:"option",
            //     hidden:false,
            //     filterOptions: {
            //         enabled: false, // enable filter for this column
            //         placeholder: "Contract Type", // placeholder for filter input
            //         filterValue: '', // initial populated value for this filter
            //         trigger: "enter" //only trigger on enter not on keyup
            //     }
            // },
            // {
            //     label: 'Unit No.',
            //     field: 'unit_no',
            //     filterable: true,
            //     fpFieldType:"text",
            //     hidden:false,
            //     filterOptions: {
            //         enabled: false, // enable filter for this column
            //         placeholder: "Unit No.", // placeholder for filter input
            //         filterValue: '', // initial populated value for this filter
            //         trigger: "enter" //only trigger on enter not on keyup
            //     }
            // },
            {
                label: 'Location',
                field:'location',
                filterable: true,
                fpFieldType:"option",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Location", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
        ],
        rows: [],
        totalRecords: 0,
        labor_cost_value: false,
        loading:false,
        canUpdateLaborCost:false,
        canAddLaborCost:false,
        action:"list"
    }),
    watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'list_labor_cost') {
                        self.cantAccessPage = true;
                    }
                    if (permissions[i].name == 'delete_labor_cost') {
                        self.labor_cost_value = true;
                    }
                    if (permissions[i].name == 'add_labor_cost') {
                        self.canAddLaborCost = true;
                        self.canUpdateLaborCost = true;
                    }
                }
            }

        }

    },
    created: function() {
        this.serverParams.sort = {field:"effective_date",type:"desc"};
    },
    mounted: function() {
        var self = this;
        self.getPermissions();
    },
     methods: {
        cancelAll: function (cancelAll) {
          this.$refs.listLaborCostTable.unselectAllInternal();
        },
        selectionChanged(param) {
            var self = this;
            self.serverParams.selectedAll = false;
            if(param.selectedRows.length == 100) {
              EventBus.$emit('clear-selection', false);
            } else {
              EventBus.$emit('clear-all-flags', false);
            }
        },

        loadList() {
            var self = this;
            self.loading = true;
            var data = this.$refs['listLaborCostTable'].selectedRows;
            var use = [];
            for (var i = 0; i < data.length; i++) {
                use.push(this.$refs['listLaborCostTable'].selectedRows[i].id);
            }
            var fields = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
                action: self.action,
                all:self.serverParams.selectedAll,
                id:use,
            };
            self.firstLoad = 1;
            $.ajax({
                url: process.env.ROOT_API + "/labor-cost/list",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    // console.log(data);
                    if (data.status == "success") {
                        if (self.action == 'delete') {

                            self.action = "list";
                            self.$refs.filterLaborCostList.clearSelectAll();
                            EventBus.$emit('clear-all-flags', false);
                            self.loadList();

                        } else {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            self.filteredFlag = false;
                        }

                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'labor-cost-list')
                }
            });
        },

        laborCostDelete() {
            var self = this;
            self.$swal({
                    title: 'Are you sure that you want to delete this Labor Cost?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                       self.action = "delete";
                       self.loadList();
                    } else {
                      console.log("no");
                    }
                });
            // if (confirm('Are you sure that you want to delete this Labor Cost? ')) {

            // }
        }
     }
}
</script>



// WEBPACK FOOTER //
// src/components/LaborCostList.vue